import { CancellationStatuses, Status } from '@/common/enums/Status';
import { Reservation } from '../reservation.model';
import { ComfortPackageDialogData, COMFORT_PACKAGE_SERVICE_ID } from '@oskar-frontend/comfort-package';

export enum ComfortPackageMode {
	DEPARTURE,
	RETURN,
	BOTH,
}

export const comfortPackageDataFactory = (data: Reservation, mode: ComfortPackageMode): ComfortPackageDialogData => {
	const offers = data.offer.filter((v) => !CancellationStatuses.includes(v?.status as Status));
	const slots = offers
		.flatMap((offer) => offer.slot)
		.filter((s) => [Status.OPTION, Status.CONFIRMED].includes(s.status as Status));
	const departureCity =
		mode === ComfortPackageMode.DEPARTURE
			? slots[0]?.stopDeparture?.stop?.location?.name
			: slots[0]?.stopReturn?.stop?.location?.name;
	const comfortPackagePrice = slots[0]?.slotServices.length
		? slots[0]?.slotServices.find((s) => s?.service?.serviceType?.id === COMFORT_PACKAGE_SERVICE_ID)?.price
		: 0;
	return {
		participantsNumber: slots.length,
		comfortPackagePrice,
		departureCity: departureCity ?? 'Poznan',
		participants: slots.map((s, index) => ({
			firstName: s.userData?.firstName ?? `Klient`,
			lastName: s.userData?.lastName ?? `${index + 1}`,
			selectedSeats: {
				...s.seatnumber,
				doubleDeckDeparture: s.seatnumber?.doubleDeckDeparture.id,
				doubleDeckReturn: s.seatnumber?.doubleDeckReturn.id,
				singleDeckDeparture: s.seatnumber?.singleDeckDeparture.id,
				singleDeckReturn: s.seatnumber?.singleDeckReturn.id,
			},
		})),
		returnId: mode === ComfortPackageMode.DEPARTURE ? null : slots[0].transportReturn,
		departureId: mode === ComfortPackageMode.RETURN ? null : slots[0].transportDeparture,
		isWWWMode: false,
	};
};
